<template>
  <el-form :rules="rules" label-position="top" ref="form" :model="data" class="demo-ruleForm">
    <el-row>
      <el-col>
        <el-form-item label="参数项" prop="pa_name">
          <el-input type="textarea" v-model="data.pa_name" :disabled="data.inputstatus" maxlength='60'></el-input>
        </el-form-item>
      </el-col>
      <el-col>
        <el-form-item label="参数值" prop="pa_value">
          <el-input type="textarea" v-model="data.pa_value" maxlength='50'></el-input>
        </el-form-item>
      </el-col>
      <el-col>
        <el-form-item label="备注" prop="opcomment">
          <el-input type="textarea" v-model="data.opcomment" maxlength='50'></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import SysParaApi from "./SysPara";
export default {
  props: {
    dat: {}
  },
  data() {
    var validateInput = (rule, value, callback) => {
      if (!this.checkSpecificKey(value)) {
        callback(new Error("存在特殊字符"));
      } else {
        callback();
      }
    };
    return {
      data: {
        uuid: "",
        pa_name: "",
        pa_value: "",
        opcomment: "",
        inputstatus: false
      },
      rules: {
        pa_name: [
          { required: true, message: "请输入参数项" },
          { validator: validateInput, trigger: ["blur", "change"] },
          {
            min: 1,
            max: 30,
            message: "长度在 1 到 30 个字符以内",
            trigger: "blur"
          }
        ],
        pa_value: [
          { required: true, message: "请输入参数值" },
          { validator: validateInput, trigger: ["blur", "change"] },
          {
            min: 1,
            max: 100,
            message: "长度在 1 到 100 个字符以内",
            trigger: "blur"
          }
        ],
        opcomment: [
          {
            min: 0,
            max: 150,
            message: "长度在 0 到 150 个字符以内",
            trigger: "blur"
          }
        ]
      }
    };
  },
  // 当前组件显示到页面之后立即执行，（挂载到页面）
  mounted() {
    this.loadInfo();
  },
  watch: {
    dat: function() {
      this.loadInfo();
    }
  },
  methods: {
    checkSpecificKey(str) {
      var specialKey =
        "[`~!#$^&*()=|{}':;'\\[\\]<>?~！#￥……&*（）——|{}【】‘；”“'。，、？]‘'";
      for (var i = 0; i < str.length; i++) {
        if (specialKey.indexOf(str.substr(i, 1)) != -1) {
          return false;
        }
      }
      return true;
    },
    loadInfo() {
      if (this.dat.uuid === undefined) {
        this.data.uuid = "";
        this.data.pa_name = "";
        this.data.pa_value = "";
        this.data.opcomment = "";
        this.data.inputstatus = false;
      } else {
        this.data.uuid = this.dat.uuid;
        this.data.pa_name = this.dat.paname;
        this.data.pa_value = this.dat.pavalue;
        this.data.opcomment = this.dat.opcomment;
        this.data.inputstatus = true;
      }
    },
    saveSysPara() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if(this.data.uuid===""){
          SysParaApi.saveSysPara(this.data).then(() => {
            this.$emit("upd", "");
          });
          }else{
          SysParaApi.updateSysPara(this.data).then(() => {
            this.$emit("upd", "");
          });
          }
        }
      });
    }
  }
};
</script>

<style>
</style>
